import { ACTIONABLE_KEYS, CSS_FLAG_KEYS } from 'config/constants';

export const isActionable = flag => ACTIONABLE_KEYS.includes(flag.name.toLowerCase());

export const hasActionableFlag = phase => phase.flags.some(isActionable);

export const isCssFlag = flag => CSS_FLAG_KEYS.includes(flag.name.toLowerCase());

export const hasCssFlag = phase => phase.flags.some(isCssFlag);



// WEBPACK FOOTER //
// ./client/app/utils/flagUtils.js